module.exports = __webpack_public_path__ + "static/media/forestCamp.df60adef.jpg";